import React from 'react';
import {
  Button,
  FormWithRedirect,
  required,
  SaveButton,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconCancel from '@material-ui/icons/Cancel';
import { makeStyles } from '@material-ui/core/styles';

import IntegrationModal from './IntegrationModal';
import { apiPost } from '../brainApi';

const useStyles = makeStyles(() => ({
  dialogWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelMargin: {
    marginBottom: 10,
  },
}));

const ConnectForm = ({ integration, closeModal }) => {
  const classes = useStyles();

  const { integration_id, connect_fields } = integration;

  const notify = useNotify();
  const refresh = useRefresh();
  const handleSubmit = async (fields) => {
    apiPost(`/integration/${integration_id}/connection`, { fields })
      .then(() => {
        notify('Connected!');
        closeModal();
        refresh();
      })
      .catch((e) => {
        console.error(e);
        notify('Failed to connect. Please try again.', 'error');
      });
  };

  return (
    <IntegrationModal closeModal={closeModal}>
      <FormWithRedirect
        resource="integration-connection"
        record={{}}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <DialogTitle>{`Connect ${integration.name}`}</DialogTitle>
            <DialogContent className={classes.dialogWrapper}>
              {connect_fields.map(
                ({ key, name, required: isRequired, type, placeholder }) => (
                  <TextInput
                    key={key}
                    source={key}
                    className={classes.labelMargin}
                    label={name}
                    placeholder={placeholder}
                    validate={isRequired ? [required()] : []}
                  />
                ),
              )}
            </DialogContent>
            <DialogActions>
              <Button label="ra.action.cancel" onClick={closeModal}>
                <IconCancel />
              </Button>
              <SaveButton
                label="Connect"
                handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                pristine={formProps.pristine}
                saving={formProps.saving}
              />
            </DialogActions>
          </>
        )}
      />
    </IntegrationModal>
  );
};

export default ConnectForm;
